"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url.js");

require("core-js/modules/web.url-search-params.js");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _recruitment = require("@/model/recruitment/recruitment");

var _vuex = require("vuex");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  mixins: [_commonMixin.default],
  data: function data() {
    return {
      satisfactionList: 11,
      index: 10,
      directionList: ["Safety advice", "Feature advice", "Design advice", "Operational advice", "Other advice"],
      direction: "Safety advice",
      detail: "",
      imageUrl: "",
      btnLoading: false,
      marketing: 0,
      contact: "",
      programForm: {
        recommend_level: 10,
        direction: "Safety advice",
        detail: "",
        picture: "",
        contact: ""
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    systemCurrency: "user/currency",
    language: "user/language"
  })),
  watch: {},
  created: function created() {
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},
  methods: {
    routeSplicing: _routeSplicing.default,
    goLogin: function goLogin() {
      if (!this.userInfo) {
        this.$message({
          message: this.translateTitle("请先登录"),
          type: "warning",
          customClass: "zZindex"
        });
        this.$router.push({
          path: this.routeSplicing(this.language, "login")
        });
      }
    },
    chooseMarketing: function chooseMarketing(index) {
      this.marketing = index;
    },
    goToRegister: function goToRegister() {
      this.$router.push(this.routeSplicing(this.language, "register"));
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.programForm.picture = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isType = file.type === "image/jpg" || file.type === "image/png" || file.type === "video/mp4" || file.type === "video/mov";
      var isLt2M = false;

      if (file.type === "image/jpg" || file.type === "image/png") {
        isLt2M = file.size / 1024 / 1024 < 2;
      }

      if (file.type === "video/mp4" || file.type === "video/mov") {
        isLt2M = file.size / 1024 / 1024 < 30;
      }

      if (!isType) {
        this.$message.error("上传文件只能是 JPG ｜ PNG | MP4 | MOV 格式!");
      }

      if (!isLt2M) {
        this.$message.error("上传文件过大");
      }

      return isType && isLt2M;
    },
    submit: function submit() {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var req, _yield$apiFormSubmitA, data, status;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                req = (0, _objectSpread2.default)({}, _this.programForm);
                _this.btnLoading = true;
                _context2.next = 4;
                return (0, _recruitment.apiFormSubmitAdvice)(req);

              case 4:
                _yield$apiFormSubmitA = _context2.sent;
                data = _yield$apiFormSubmitA.data;
                status = _yield$apiFormSubmitA.status;
                _this.btnLoading = false;

                if (!(status == 200)) {
                  _context2.next = 11;
                  break;
                }

                _this.programForm = {
                  recommend_level: 10,
                  direction: "",
                  detail: "",
                  picture: "",
                  contact: ""
                };
                return _context2.abrupt("return", _this.$message("反馈成功", "sucess"));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};
exports.default = _default;